import React, { createContext, Dispatch } from "react"
import { TelefoneBloqueadosInicial, TelefoneBloqueadosModel } from "../models/telefonesBloqueadosModel"
import { TelefoneBloqueadosActions } from "./telefonesBloqueadosActions"

interface TelefoneBloqueadosContextValue {
    dados: TelefoneBloqueadosModel
    dispatch: Dispatch<TelefoneBloqueadosActions>
    erroCarregamento: string | null
}

export const TelefoneBloqueadosContext = createContext<TelefoneBloqueadosContextValue>({
    dados: TelefoneBloqueadosInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
